  (function (t, e) {
    typeof define == "function" && define.amd
      ? define([], e)
      : typeof exports == "object"
      ? (module.exports = e())
      : (t.Marquee3k = e());
  })(this, function () {
    "use strict";
    let t = 0;
    class e {
      constructor(t2, e2) {
        (this.element = t2),
          (this.selector = e2.selector),
          (this.speed = parseFloat(t2.dataset.speed) || 0.75),
          (this.pausable = t2.dataset.pausable === "true" ? 1 : -1),
          (this.reverse = t2.dataset.reverse === "true" ? 1 : !1),
          (this.paused = !1),
          (this.parent = t2.parentElement),
          (this.parentProps = this.parent.getBoundingClientRect()),
          (this.content = t2.children[0]),
          (this.innerContent = this.content.innerHTML),
          (this.wrapStyles = ""),
          (this.offset = 0),
          this._setupWrapper(),
          this._setupContent(),
          this._setupEvents(),
          this.wrapper.appendChild(this.content),
          this.element.appendChild(this.wrapper),
          (this.lastFrameTime = null);
      }
      _setupWrapper() {
        (this.wrapper = document.createElement("div")),
          this.wrapper.classList.add("marquee3k__wrapper"),
          (this.wrapper.style.whiteSpace = "nowrap");
      }
      _setupContent() {
        this.content.classList.add(`${this.selector}__copy`),
          (this.content.style.display = "inline-block"),
          (this.contentWidth = this.content.offsetWidth),
          (this.requiredReps =
            this.contentWidth > this.parentProps.width
              ? 2
              : Math.ceil(
                  (this.parentProps.width - this.contentWidth) / this.contentWidth
                ) + 1);
        for (let t2 = 0; t2 < this.requiredReps; t2++) this._createClone();
        this.reverse && (this.offset = -1 * this.contentWidth),
          this.element.classList.add("is-init");
      }
      _setupEvents() {
        this.element.addEventListener("mouseenter", () => {
          this.pausable && (this.paused = true);
        }),
          this.element.addEventListener("mouseleave", () => {
            this.pausable && (this.paused = false);
          });
      }
      _createClone() {
        const t2 = this.content.cloneNode(!0);
        (t2.style.display = "inline-block"),
          t2.classList.add(`${this.selector}__copy`),
          this.wrapper.appendChild(t2);
      }
      animate() {
        if (!this.paused) {
          const currentTime = Date.now();
          let deltaTime = 0;
          this.lastFrameTime && (deltaTime = currentTime - this.lastFrameTime),
            (this.lastFrameTime = currentTime);
          const distanceToMove = (this.speed * deltaTime) / 16,
            t2 = this.reverse ? this.offset < 0 : this.offset > -1 * this.contentWidth,
            e2 = this.reverse ? -1 : 1,
            s = this.reverse ? -1 * this.contentWidth : 0;
          t2
            ? (this.offset -= distanceToMove * e2)
            : (this.offset = s),
            (this.wrapper.style.whiteSpace = "nowrap"),
            (this.wrapper.style.transform = `translate(${this.offset}px, 0) translateZ(0)`);
        }
      }
      _refresh() {
        this.contentWidth = this.content.offsetWidth;
      }
      repopulate(t2, e2) {
        if (((this.contentWidth = this.content.offsetWidth), e2)) {
          const e3 = Math.ceil(t2 / this.contentWidth) + 1;
          for (let t3 = 0; t3 < e3; t3++) this._createClone();
        }
      }
      static refresh(t2) {
        MARQUEES[t2]._refresh();
      }
      static pause(t2) {
        MARQUEES[t2].paused = !0;
      }
      static play(t2) {
        MARQUEES[t2].paused = !1;
      }
      static toggle(t2) {
        MARQUEES[t2].paused = !MARQUEES[t2].paused;
      }
      static refreshAll() {
        for (let t2 = 0; t2 < MARQUEES.length; t2++) MARQUEES[t2]._refresh();
      }
      static pauseAll() {
        for (let t2 = 0; t2 < MARQUEES.length; t2++) MARQUEES[t2].paused = !0;
      }
      static playAll() {
        for (let t2 = 0; t2 < MARQUEES.length; t2++) MARQUEES[t2].paused = !1;
      }
      static toggleAll() {
        for (let t2 = 0; t2 < MARQUEES.length; t2++)
          MARQUEES[t2].paused = !MARQUEES[t2].paused;
      }
      static init(s = { selector: "marquee3k" }) {
        if (s && s.dataset && s.dataset.scrolling) {
          let animate = function () {
            for (let t2 = 0; t2 < MARQUEES.length; t2++) MARQUEES[t2].animate();
            requestAnimationFrame(animate);
          };
          const i = Array.from(s.querySelectorAll(".marquee3k"));
          let n, r = window.innerWidth;
          for (let t2 = 0; t2 < i.length; t2++) {
            const n2 = i[t2],
              r2 = new e(n2, s);
            MARQUEES.push(r2);
          }

          requestAnimationFrame(animate),
            window.addEventListener("resize", () => {
              clearTimeout(n),
                (n = setTimeout(() => {
                  const t2 = r < window.innerWidth,
                    e2 = window.innerWidth - r;
                  for (let s2 = 0; s2 < MARQUEES.length; s2++) MARQUEES[s2].repopulate(e2, t2);
                  r = this.innerWidth;
                }, 250));
            });
        } else {
          let animate = function () {
            for (let t2 = 0; t2 < MARQUEES.length; t2++) MARQUEES[t2].animate();
            requestAnimationFrame(animate);
          };
          t && window.cancelAnimationFrame(t), (window.MARQUEES = []);
          const i = Array.from(document.querySelectorAll(`.${s.selector}`));
          let n, r = window.innerWidth;
          for (let t2 = 0; t2 < i.length; t2++) {
            const n2 = i[t2],
              r2 = new e(n2, s);
            MARQUEES.push(r2);
          }
          requestAnimationFrame(animate),
            window.addEventListener("resize", () => {
              clearTimeout(n),
                (n = setTimeout(() => {
                  const t2 = r < window.innerWidth,
                    e2 = window.innerWidth - r;
                  for (let s2 = 0; s2 < MARQUEES.length; s2++) MARQUEES[s2].repopulate(e2, t2);
                  r = this.innerWidth;
                }, 250));
            });
        }
      }
    }
    return e;
  }),

  Marquee3k.init();

 